/* Waka — ajustes y piezas nuevas (25 ago 2026)
   1) Catalogo: aviso Coming soon en familias sin stock (Poleras). El filtrado en
      si vive en la seccion "Filtros desde la URL", que es la que manda: aca solo
      se muestra u oculta el aviso.
   2) Pie: logo con su frase en una mitad y la lista waka en la otra.
   3) Pagina del drop: fotos servidas en 200 px, sin seleccion ni arrastre.
   4) Pagina de redes: numeracion de los recuadros de relleno.
   5) Lista de deseados: el corazon guarda en el navegador y la pagina Mi cuenta
      muestra lo guardado, el carro y los accesos al perfil. */
(function(){
  var SOON=['poleras'];
  var TXT={k:'En camino',t:'Coming soon',d:'Las poleras waka todavia no salen. Deja tu correo en el pie y te avisamos primero.'};
  var ANCHO='200';
  var WKEY='wakaWish';

  function norm(s){return (s||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,' ').trim()}
  function money(c){
    try{return new Intl.NumberFormat('es-CL',{style:'currency',currency:'CLP',maximumFractionDigits:0}).format(c/100)}
    catch(e){return '$'+Math.round(c/100)}
  }

  /* ---------- lista de deseados ---------- */
  function wishGet(){
    try{var v=JSON.parse(localStorage.getItem(WKEY)||'[]');return Array.isArray(v)?v.filter(Boolean):[]}catch(e){return []}
  }
  function wishSet(list){
    try{localStorage.setItem(WKEY,JSON.stringify(list))}catch(e){}
    wishBadges();
  }
  function wishHas(h){return wishGet().indexOf(h)>-1}
  function wishToggle(h){
    if(!h)return false;
    var l=wishGet(),i=l.indexOf(h);
    if(i>-1)l.splice(i,1); else l.unshift(h);
    wishSet(l);
    return i<0;
  }
  function wishBadges(){
    var n=wishGet().length;
    [].slice.call(document.querySelectorAll('[data-wish-count]')).forEach(function(el){
      el.textContent=n?'('+n+')':'';
    });
  }
  function handleOf(btn){
    var h=btn.getAttribute('data-wish-handle');
    if(h)return h;
    var m=location.pathname.match(/\/products\/([^/?#]+)/);
    return m?m[1]:'';
  }
  function paintHearts(){
    [].slice.call(document.querySelectorAll('[data-wish]')).forEach(function(b){
      var on=wishHas(handleOf(b));
      b.classList.toggle('on',on);
      b.innerHTML=on?'&#9829;':'&#9825;';
      b.setAttribute('aria-pressed',on?'true':'false');
    });
  }
  document.addEventListener('click',function(e){
    if(!e.target.closest)return;
    var b=e.target.closest('[data-wish]');
    if(!b)return;
    e.preventDefault();
    wishToggle(handleOf(b));
    paintHearts();
    if(document.querySelector('[data-acc-wish]'))pintarDeseados();
  },true);

  /* ---------- catalogo: solo el aviso Coming soon ---------- */
  function catalogo(){
    var grid=document.querySelector('[data-cgrid]');
    var fchips=document.querySelector('[data-fchips]');
    if(!grid||!fchips)return;

    var soon=document.querySelector('.wk-soon');
    if(!soon){
      soon=document.createElement('section');
      soon.className='wk-soon';
      soon.innerHTML='<span class="k"></span><span class="t"></span><span class="d"></span>';
      soon.querySelector('.k').textContent=TXT.k;
      soon.querySelector('.t').textContent=TXT.t;
      soon.querySelector('.d').textContent=TXT.d;
      grid.parentNode.insertBefore(soon,grid);
    }
    var meta=document.querySelector('.cmeta');
    var catbar=document.querySelector('[data-catbar]');

    function sync(){
      var on=fchips.querySelector('button.on');
      var isSoon=SOON.indexOf(norm(on?(on.getAttribute('data-label')||on.textContent):''))>-1;
      soon.classList.toggle('on',isSoon);
      grid.classList.toggle('wk-off',isSoon);
      if(meta)meta.classList.toggle('wk-off',isSoon);
      var pg=document.querySelector('.pager');if(pg)pg.classList.toggle('wk-off',isSoon);
      var ft=document.querySelector('.cfoot');if(ft)ft.classList.toggle('wk-off',isSoon);
      if(catbar)catbar.classList.toggle('is-off',isSoon);
    }
    window.WAKA_SOON_SYNC=sync;
    document.addEventListener('click',function(e){
      if(e.target.closest&&e.target.closest('.cbar .chips button'))setTimeout(sync,0);
    });
    sync();
  }

  /* ---------- pagina Mi cuenta ---------- */
  function pintarDeseados(){
    var box=document.querySelector('[data-acc-wish]');
    if(!box)return;
    var vacio=box.querySelector('.acc-empty');
    if(!box._empty&&vacio)box._empty=vacio.cloneNode(true);
    var list=wishGet();
    if(!list.length){
      box.innerHTML='';
      if(box._empty)box.appendChild(box._empty.cloneNode(true));
      return;
    }
    Promise.all(list.map(function(h){
      return fetch('/products/'+encodeURIComponent(h)+'.js')
        .then(function(r){return r.ok?r.json():null})
        .catch(function(){return null});
    })).then(function(items){
      var grid=document.createElement('div');
      grid.className='wgrid';
      var vivos=[];
      items.forEach(function(p,i){
        if(!p)return;
        vivos.push(list[i]);
        var img=(p.featured_image||(p.images&&p.images[0])||'');
        if(img&&img.indexOf('//')===0)img='https:'+img;
        var sep=img&&img.indexOf('?')>-1?'&':'?';
        var a=document.createElement('article');
        a.className='wcard';
        a.innerHTML='<button class="x" type="button" data-wish-del="'+list[i]+'" aria-label="Quitar">&#10005;</button>'+
          '<a class="im" href="/products/'+list[i]+'">'+(img?'<img src="'+img+sep+'width=700" alt="" loading="lazy">':'')+'</a>'+
          '<a class="n" href="/products/'+list[i]+'">'+p.title+'</a>'+
          '<div class="r"><span>'+(p.type||'')+'</span><span>'+money(p.price)+'</span></div>';
        grid.appendChild(a);
      });
      if(vivos.length!==list.length)wishSet(vivos);
      box.innerHTML='';
      if(!grid.children.length){if(box._empty)box.appendChild(box._empty.cloneNode(true));return}
      box.appendChild(grid);
    });
  }

  function pintarCarro(){
    var box=document.querySelector('[data-acc-cart]');
    if(!box)return;
    var vacio=box.querySelector('.acc-empty');
    if(!box._empty&&vacio)box._empty=vacio.cloneNode(true);
    fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
      if(!c.items||!c.items.length){
        box.innerHTML='';
        if(box._empty)box.appendChild(box._empty.cloneNode(true));
        return;
      }
      var wrap=document.createElement('div');
      wrap.className='clines';
      c.items.forEach(function(it){
        var img=it.image||'';
        if(img&&img.indexOf('//')===0)img='https:'+img;
        var sep=img&&img.indexOf('?')>-1?'&':'?';
        var row=document.createElement('div');
        row.className='cline';
        row.innerHTML=(img?'<img src="'+img+sep+'width=200" alt="" loading="lazy">':'<div></div>')+
          '<div class="t"><b>'+it.product_title+'</b><span>'+(it.variant_title&&it.variant_title!=='Default Title'?it.variant_title+' \u00b7 ':'')+it.quantity+' u.</span></div>'+
          '<div class="p">'+money(it.line_price)+'</div>';
        wrap.appendChild(row);
      });
      var tot=document.createElement('div');
      tot.className='ctot';
      tot.innerHTML='<b>Total '+money(c.total_price)+'</b><a href="/cart">Ir a pagar &#8599;</a>';
      box.innerHTML='';
      box.appendChild(wrap);
      box.appendChild(tot);
    }).catch(function(){});
  }

  function cuenta(){
    var acc=document.querySelector('[data-acc]');
    if(!acc)return;
    function show(name){
      [].slice.call(acc.querySelectorAll('[data-acc-pane]')).forEach(function(p){
        p.classList.toggle('on',p.getAttribute('data-acc-pane')===name);
      });
      [].slice.call(acc.querySelectorAll('[data-acc-tab]')).forEach(function(b){
        b.classList.toggle('on',b.getAttribute('data-acc-tab')===name);
      });
      if(name==='deseados')pintarDeseados();
      if(name==='carro')pintarCarro();
      if(history.replaceState)history.replaceState(null,'','#'+name);
    }
    acc.addEventListener('click',function(e){
      if(!e.target.closest)return;
      var t=e.target.closest('[data-acc-tab]');
      if(t){show(t.getAttribute('data-acc-tab'));return}
      var g=e.target.closest('[data-acc-go]');
      if(g){show(g.getAttribute('data-acc-go'));return}
      var d=e.target.closest('[data-wish-del]');
      if(d){wishToggle(d.getAttribute('data-wish-del'));pintarDeseados();paintHearts();}
    });
    var h=(location.hash||'').replace('#','');
    if(['inicio','perfil','pago','carro','deseados'].indexOf(h)>-1)show(h); else show('inicio');
    pintarCarro();
  }

  /* el icono de cuenta del encabezado lleva a la pagina del tema */
  function enlaceCuenta(){
    [].slice.call(document.querySelectorAll('header a[href*="/account"], #menuPanel a[href*="/account"]')).forEach(function(a){
      if(a.getAttribute('data-keep-account'))return;
      if(/logout/.test(a.getAttribute('href')||''))return;
      a.setAttribute('href','/pages/cuenta');
    });
  }

  function pie(){
    var brand=document.querySelector('footer .ft-brand');
    if(!brand)return;
    if(!brand.querySelector('.wk-fmark')){
      var mark=document.createElement('div');
      mark.className='wk-fmark';
      var logo=brand.querySelector('.ft-logo, .brandmark');
      var txt=brand.querySelector(':scope > p');
      if(logo){brand.insertBefore(mark,logo);mark.appendChild(logo);}
      else{brand.insertBefore(mark,brand.firstChild);}
      if(txt)mark.appendChild(txt);
    }
    var news=document.getElementById('ftNews');
    if(news&&news.parentNode!==brand)brand.appendChild(news);
  }

  function chica(img){
    var src=img.getAttribute('src')||'';
    if(!src||img.dataset.wkLow===ANCHO)return;
    try{
      var u=new URL(src,location.href);
      u.searchParams.set('width',ANCHO);
      u.searchParams.delete('height');
      u.searchParams.delete('crop');
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.dataset.wkLow=ANCHO;
      img.setAttribute('draggable','false');
      img.setAttribute('alt','');
      if(u.href!==src)img.setAttribute('src',u.href);
    }catch(e){}
  }

  function drop(){
    var zone=document.querySelector('.look .look-grid');
    if(!zone)return;
    [].slice.call(zone.querySelectorAll('img')).forEach(chica);
    var stop=function(e){e.preventDefault();return false};
    zone.addEventListener('contextmenu',stop);
    zone.addEventListener('dragstart',stop);
    zone.addEventListener('selectstart',stop);
    if(window.MutationObserver){
      new MutationObserver(function(){[].slice.call(zone.querySelectorAll('img')).forEach(chica)}).observe(zone,{childList:true,subtree:true,attributes:true,attributeFilter:['src','srcset']});
    }
  }

  function redes(){
    var zones=document.querySelectorAll('.soc-grid .ptrack, .soc-grid .pgrid');
    for(var z=0;z<zones.length;z++){
      var tags=zones[z].querySelectorAll('.pcell .ph-tag');
      var n=0,total=tags.length;
      for(var i=0;i<tags.length;i++){
        if(!/^post\s*\d+$/i.test(tags[i].textContent.trim()))continue;
        n++;
        var half=total/2;
        tags[i].textContent='post '+(zones[z].classList.contains('ptrack')&&n>half?n-half:n);
      }
    }
  }

  function init(){pie();catalogo();drop();redes();paintHearts();wishBadges();cuenta();enlaceCuenta()}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',function(){pie();drop();redes();paintHearts();enlaceCuenta()});
})();
